import { ICON_SIZES, ICONS } from '../constants/icons';
const makeIconName = (name, size) => {
    return `${ICONS[size][name]}_${ICON_SIZES[size]}`;
};
export default makeIconName;
